import React from 'react';
import MobileStepper from '@material-ui/core/MobileStepper';

const activePageIndicator = ({
    activePage,
    pagesCount,
}) => {
    return (
        <MobileStepper
            variant="dots"
            steps={pagesCount}
            position="static"
            activeStep={activePage}
            nextButton={<div></div>}
            backButton={<div></div>}
        />
    );
};

export default activePageIndicator;
